import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the NotificaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-notifica',
  templateUrl: 'notifica.html',
})
export class NotificaPage {
  public searchTerm;
  utenti: string[];
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private alertCtrl: AlertController,

    ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NotificaPage');
  }

  cercaUtente(){
    this.rest.searcUserClient(this.searchTerm).subscribe(
      utenti => this.utenti = utenti,
      error => this.errorMessage = <any>error);
  }
  confermaUtente(utente){
    let alert1 = this.alertCtrl.create({
      title: utente.username,
      subTitle: "Vuoi mandare notifica a questo utente?",
      enableBackdropDismiss: false, // <- Here! :)
      buttons: [
        {
          text: 'Annulla ',
          role: 'cancel',

          handler: () => {
            console.log('Cancel clicked');
           

          },

        },
        {
          text: 'Conferma',
          handler: data => {

          
            this.rest.notificaSuper(utente);
            // this.ordineItem.consegnaPrevisto = this.ordineItem.consegnaPrevisto.substring(0, this.ordineItem.consegnaPrevisto.length - 3);

          }
        }
      ]
    });
    alert1.present();


  }
}



// WEBPACK FOOTER //
// ./src/pages/notifica/notifica.ts